// 拖拽指令
import drag from './drag'

const install = function(Vue) {
  Vue.directive('wd-drag', drag)
}

if (window.Vue) {
  window['wd-drag'] = drag
  Vue.use(install); // eslint-disable-line
}

drag.install = install
export default drag